// extracted by mini-css-extract-plugin
export default {"actions":"table-actions_actions__pNz0R","seeBoletoLink":"table-actions_seeBoletoLink__uenKV"};